export const noUser = {
  id: '',
  last_name: 'User',
  first_name: 'No',
  avatar_image_url: '',
  name: 'No user',
};
